import { useLayoutEffect } from 'react';

import { replaceModal } from '#modals/modalsSlice';
import { useDispatch } from '#redux';

export function CreateAccountModal() {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(replaceModal({ modal: { name: 'add-local-account' } }));
  }, [dispatch]);

  return null;
}
